import { Injectable, inject } from '@angular/core';
import { ProjectModel } from '../../../../../../../core/models/project/project.model';
import { BudgetOptions } from '../../../../../../../core/constants-repository/project-calculation.constants';
import { BudgetEntryService } from './budget-entry.service';
import { assert } from '../../../../../../../core/assert/assert';
import { FeeUnit } from '../../../../../../../shared/data-types/unit-types';

@Injectable({
  providedIn: 'root',
})
export class BudgetCalculationService {
  private readonly budgetEntryService = inject(BudgetEntryService);

  public static getFeeUnit(project: ProjectModel): FeeUnit {
    if (
      project.budgetType === BudgetOptions.TotalProjectMonetaryBudget ||
      project.budgetType === BudgetOptions.MonetaryPerTask
    ) {
      return 'monetary';
    }
    return 'seconds';
  }

  public getBudgetForTask(project: ProjectModel, taskId: number): number | null {
    if (project.budgetType === BudgetOptions.MonetaryPerTask) {
      return this.budgetEntryService.getEntryForTask(project, taskId).monetary;
    } else if (project.budgetType === BudgetOptions.HoursPerTask) {
      return this.budgetEntryService.getEntryForTask(project, taskId).seconds;
    }
    return 0;
  }

  public getBudgetForMember(project: ProjectModel, memberId: number): number | null {
    if (project.budgetType === BudgetOptions.HoursPerMember) {
      return this.budgetEntryService.getEntryForMember(project, memberId).seconds;
    }

    return 0;
  }

  public calculateBudget(project: ProjectModel): number | null {
    if (project.budgetType === BudgetOptions.TotalProjectMonetaryBudget) {
      assert(project.projectBudgetEntries.length === 1);
      const projectBudgetEntry = project.projectBudgetEntries[0];
      return projectBudgetEntry.monetary;
    } else if (project.budgetType === BudgetOptions.MonetaryPerTask) {
      return project.projectBudgetEntries.reduce((acc, entry) => {
        assert(entry.taskId !== null);
        return acc + entry.monetary!;
      }, 0);
    } else if (project.budgetType === BudgetOptions.TotalProjectHours) {
      assert(project.projectBudgetEntries.length === 1);
      const projectBudgetEntry = project.projectBudgetEntries[0];
      return projectBudgetEntry.seconds;
    } else if (project.budgetType === BudgetOptions.HoursPerTask) {
      return project.projectBudgetEntries.reduce((acc, entry) => {
        assert(entry.taskId !== null);
        return acc + entry.seconds!;
      }, 0);
    } else if (project.budgetType === BudgetOptions.HoursPerMember) {
      return project.projectBudgetEntries.reduce((acc, entry) => {
        assert(entry.memberId !== null);
        return acc + entry.seconds!;
      }, 0);
    }
    return project.projectBudgetEntries.reduce((acc, entry) => {
      assert(entry.memberId !== null);
      return acc + entry.seconds!;
    }, 0);
  }
}
